<template>
  <div class="face" id="face">
      <i class="icon icon-face" title="表情" @click="toggleShow"></i>
      <main class="face-main" :class="[isH5 && 'face-H5-main']" v-show="show" ref="dialog">
         <ul class="face-list" v-for="(item, index) in list" :key="index" v-show="currentIndex === index">
          <li  class="face-list-item" v-for="(childrenItem, childrenIndex) in item" :key="childrenIndex" @click="select(childrenItem, childrenIndex)" slot="reference" @click.prevent.right="rightClick(childrenItem, childrenIndex, index)">
            <img v-if="index === 0" :src="emojiUrl + emojiMap[childrenItem]">
            <el-upload v-else-if="index === 1 && childrenIndex === 0" class="add-emoj" :show-file-list="false" 
                        :file-list="uploadEmojiList" :on-success="handleSuccess" :action="uplodImgAction" :headers="myHeaders"
                   accept="image/jpg,image/jpeg,image/png,image/gif" >
              <img src="data:image/png;base64,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">
            </el-upload>
            <img  v-else-if="index === 1 && childrenIndex !== 0" class="face-img" :src="autoEmojURL + childrenItem.imageUrl"/>
            <img class="face-img" v-else :src="faceUrl + childrenItem + '@2x.png'">
            <!-- <div class="popover"> -->
            <div v-if="index === 1 && childrenIndex !== 0 && visibleId === childrenItem.id" class="popover">
              <el-button @click.stop="delAutoEmoj(childrenItem, childrenIndex)">删除</el-button>
            </div>
          </li>
        </ul>

        <ul class="face-tab">
          <li  class="face-tab-item" @click="selectFace(0)">
            <i class="icon icon-face"></i>
          </li>
          <li  class="face-tab-item" @click="selectFace(1)">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABCCAYAAAD9nTBbAAAAAXNSR0IArs4c6QAAENZJREFUeF7dXGuQFFWW/r6TmdVV3UADDY28wRcCgzqoICyKsz5wnEFnN1Z3wtjH6M4Q4WvYMWJ3IzY2Jtr94cTGzu6fiRgjDN2Y2NmYmdDYiVUcFR8raBC8FBHBgREE6QalsWmg31WVeTZuVmV1VlZWVTbdjcYmP5qqvn3vze9+95zvnHMziYSX3gsLc+ak+ic1TYGnsx1aV1kqV4JcSOVMFUwDMRFgBoAN0gXQr2CXkJ+pp0dc4qO84gDUO56hcwZLLh3ifc+bdokvbbvFRlOqYWBocCpE59kOlliWvZiQS6GYBXIagEaQFsg8PB0A2QPoF0p2Ajjmevk/5F33IEQ7MhOauzAlnXgeTDrT7r9dMDmTSbeq482Fcr4NXiGQS0mZp0AryKkgmgA6fp/0u86D7AZxiopjruJjpRykylHb0XZkU51s234m6RxMO/3pLdOQdVvzgrkKbwHFXmQJL4fIAoCtAKcCcIrjmz/JAegDcAbgF1C0u3A/Uc87TOExm9IOtU7x8c2J5pEIsI5HZrdMTqeWZxrsFZ4lX1fFPFImCzgJ4AQAGZASAioALPiZBaVHoeeo0q3EcVr4IJeV3fmc9d6EJ3eeSgJa/7+snJNS6zrCvp6iy1Q5F+RkCptJGnangOItFRZseB6AB2AQQK+qnlfiHKHtCn6Qc72duV77vYltrxkG1rxqAqZtC9JfnM/Nc1zrmlSDsyblWCso8jVVTGAwodIEC3iVVjY64SKe5oZI9HmU3+dd3Z3PcweBDxszcpz/uKsrOlt/Czb2TRtQWUCXyxzLWiGwridxlYLpYLzSfErjRuYTBwPRD+CjXE53ZbPY5lH2TMw2HGfbJvN97FUVMN1wndPX/PlSgXOH0LpZyCVisZUiTarDwCQHbvgGzKBKDqiy01MeA/iuiLvFyusePvH+yWCm2gZBw6pLXbg3gLgJtK8lZA7B6STS6i9WOZNGBJw/EQx4ik5P9ZAHvE1ys2PbH/KHrwzFYxzzrbbNaoRrL87mcatF+1tUa7kSZuuFGBTswADzYOLVmBZdcRb7ogfikNJ7G4q3LPX2wLW60Sg2ct4sj9YNgNxM4WpAFhQYpUCIsYV5ReYzEqYVMBhQcK/C+51Y1usY0gP8u9eM7Su7KhhmVjXnzrrGEfs7+SFZJ7SWAJioZgKGWsFEI1suMGGVNqQWgGZ7+lPIKfAZVXcruVWpxyxKk6dcSrFWAVxCYoYZ3J9HGLAqpmFETPMB93HpU9VD6jivuq77W2dm896oFy8D7LmlSF29ZNrCKxal7xTb+nN3kNeVDGm1FSt+f2GAmb1dBugpku8rcByiTVRZBMpVvmOpACqGsWPDNBe2857nus91nO185UDX+0fu+hlK27MMsGdmpuevWdN016IrG++GJavcITQXJhq2FbWN+4UBN7zEII1776WIkSfNABv98asxK7qQFTYtOt8EzsC2e9XTnZ91nXph/8lPXlr3zLmjwb70ATMb7Zcz0Ng6r2nVssWTHpg527kVwhle3vwmACsOqOBGwk6g2K7CvdexbeH2frdj0I8/rTrzjrPslgV42tXdc+7N4198/h/dub5tW1tP97e1waOB5KX1yLTaTVfMmdS0bsoU5/5USq42xkU9BaUIWOkGiiP4nysBG3bzo7hhf8hqTiWhcxkN04qszeWz+3sHB3/d1Z979ZNs7tD2CfsG2NYGWdPRNH3ZhPQdren0PQBvzrs6HVoAwzee/g1EvaH5bFV+7wOcgCHBDRXbV3q9wrh1mZaknwtlmvA0yG1nh/Dixzr0yrEF009z81+iKdOQumzxpEkPTEs33A2P8/N5zyBRoFKw0sGNla1cAJgvzIbbxwBcsTXqtC8BGBn3gvuJOqfA1FRGBMObVOhCpKM3ixc/zemzpweHjnDrA5m5E0SWzmvMPDq1IXUbyQa3oEzLAatQ7sFWreIURnKjZqSKBYm3eTUBS9BPOWMVkIhpCdu0AgTZnjze7My7PxuEHODJh6bcZAFLJ6TsHzRY9nIzcfX1VrwgLdc3JfEZ334smVZN98XNM9aExMsQH0Df7EQkaehzzsXeAc97xhP9kPmNLX+lkMUU/plSLi8QK9zB/0+mBTuowLiAaWXyJsQ1HoF6v4XyI7o/mvYEPF6pgm8oOKMyeI73duVbowbTfMpXOo2qW6tK+7oRRpRpSfspmp4C06o5N3QCugXgIWZ/2PIshJcRXO4nACt0SxLAgoFCwEWzGF9Rm1bOtDhb6odiParYq8BhDm2c9jKhC0leXsiUjkBgVrjrWkyL6KfSysZ/X3ICCQXssG2NLHAt2RJSASXg4tsbCX8EkKPMbmzZocB8IS8Jy4gL25q1mBboufIbqnqjwRYLtladyGHU/UQXMDKugibJ+SlzG6ceBDCvmIuvSN9cGHD1maaBvvtKM23Y+Sk4AOA4sxunHicwC6BVZpyjW6EOtevrm5BuM5mipICVIo1koVZNpoVCrqppqPAChuSGAqZYc5LZjZNPQWGKB+UhzZjrm7DQrS5UR22LSop+lLYxwKMYSxfycOhk9rHJpwFTIksAWAIlXVvfxGzVSHpmzBhSJ0aNjV3jnECRZSa0BtDF7KPNxpiZMlmZXhptzFYGXEnfhMKo2FCrVpaiuCXrhVCRGLVqzSFRPyEBX2jfydyjze0KzA5yxePDtOgWHAHTonquAug6mdd6wEQTkGWmKJy+MuEATjD7yMRDgM4BJZTZjEkIjlZJlynvMWDaSIDz7zs+Nq6qAiqAMyU5thvAdvuygpxeTIAl35ojtmkB04JsSCifVgWA0d1orfTUCKpbMHlWnAZ4nEMPT3yZVFNmvwxAahjx8g5H7b3KvE7AYKNk/NCjrv6rm0isubXMQlXL4CYBjlkoj5hzGcw+3OTHklAuN+W0EQOWVJFXKOlwHi1sK+rkwerWCsbSppXKij1Q7lHFEQ491PhPABeBvJXEzHp1xbFlWlywHtFP1bx3XeBq67DkjPX7+Uwpb4rJVvT/IPVdQpaKLd+lOQVTXiesKNyOmU4qKfjxYloVwIrjjgQwhR72FL/xgAPs+xvHnMZZ5jj2Q7R4I0Hff1ZN84yTko6vf451pT2UIExQrPGxoDn24+3IgU95ig/Z+33M0Ly92EnZD4st6whOMPnHenmxQvktBGykrjgyJR3KcpRtNbNl49M1dRmSpJpUpyrlY0X2utTNA57+nJ7+nvo9pHs8zGtIp+6lZa8ndImCVY1/tDo0OiUddfvB9gyniYop5HGuSsUtAMEeJT9yoZtc9Z5vyDYepzmK2ZPBZGmwr7ct5x4LWK/knGresn75LYmbDufOI+6+zMhfpAxuVaZph6fYlAdeyBLvTrx8/ll/X2kb7L4OtMBy7nJobSDkRjPvgi2r4rWSxmwjUeT+cOGY9iJWpUIhVGEOhAfdkcu7T7t29uWm3LQutm3JB/GCb470IedG2PIgYH0LLmbk1C9tF4sDY6lv4ooNXwGmFQ8Kik0Xtt0Jur+Dm3+W/7BnR1BCKgfsYVwCddaBco+qrMmrTk+c40/gdWITlFVivMRMG4eqlFg8DcE2qPcCrKFX+fcHPo8F7Ll7kWnuT102JcN1Cyfi/slpXg0RW81x2mpbKyIgmTAHX7EQX4FKe8EhM392wNv3SffAr7r7s69192UP3/d8h0lPF9Y7+E/wc9UcZFZMsW/4i0Xy19fN4G0QmZ3PqTV+TKshTy5yVYoNlgsPJ97v6H/jvz7s/s/DRz7fvemkf3C4dFUAZn6zqgWzf7zSuf3O+bwHNm7K56QlyMEnYlqSUzdJGVvzfFdUhgwH2cMJzNoLEgTlpr2kpQt5vPPqwXMv/PNbJ1/f3jFwIkqoWMBuAezH78Dc9fPlm0g59+fzWAGKo3FnS6NeNCIY6wrMCwKuflUqKnhrxcBG0QPMMSO7MKS/2vRx9yv//stP27eYBzMiVyxgQRt9ENegwb4v58q3KTTn4lPVlPeXe74rwjT/Y/L6J8msQg5KCi8hn3uOPz7wQRSoqjYs3FB/hAz6cN2Q2utF5G6AV8We6inl7CsF6TDli0YzusWSnhOLLdKMEdOIgx74ou3IJjQ2vsfHt5eM/IgY5muzxzBpaMBeCfJeodwO4dzi0cMiAvWKE4F7CXRWbT1X75xY9fpnsFhFtpWyITWZ5ppnjxR4TS153tbGXXxi5/lq7Ir1knGNz2/AtJRaqwH720LcAWJ+UqYV63kVh3MvWlWqShGkOP4xVWwG5CXLzW/nTw5WPLozYoYFf9D7PVziOKlVIP6U5FqQs5Iw7YIAM4PWq/aUFZ6j57vqVaXUJXgCqlsV1n9bKjv45P5ED4jVNPpl9gxg/wZcYmtqtUK/SZFbCRQfZQmRNem5rHqF46T9xJ7vqlWV8rMf5tz9GwBesbLOdv7rsJKvtR0Tb8lwJ30bMNNmahVUvzPMNNrRLEZdhtQDLHAOI2JatCplDsmV2cw8iHYAWwH9HyvbsHMkYF0QYCYHapgGWCst4E5SbiPksgqblvRc1rhkcINQzoA1DJgCfyDxOojNlrq7+OTRRNuwrtKvR0vze5Optc2TZsR6wlpL4XyY5xejxYmEseXYn+8KtqUBjANKHCW4FdRNlvJd/uSwOVMy4iuxDYv1no+gRbL21wW43RI/vf01/1lr/yp2/aUyzU9xmyfl9gF4FbDesNOD+9jWkehx5bh7HhVgpsPTD2Ji2sJyh/ZdIvINklcSbDYPf5YeRI1R3uWJyeFix+iqUoWKuvknFFPAOOOpEaV4S4iX7UxuL9tOVn3aNgndRg2YGaTrMUxKD2KRBVkrYt1JWssVmPLlMM2Hy6SjOl0P7yq8zXnq201N2cNsO92bBJRRC9ckg/hp7mNYDMitSrnFtuVay+JMQlKlVHddpg1v5QupSpnuzaPRec89kYXucV3dYlvuWxP/retQkHFPci8XBTAziD6Ghs6TmO1Z1vVNTXJ7OsVVIrzS88xrEWLOwfvhSyhwDtu+YvtkValCP0IZBHjgvDu07aw7+L/q5vYuzA2e5NP+qxjG5BqTLRmdyeE/QWtLU2p1U5OuFeEqz5Mr/PdaBA/XB8F6CbCwwinPX5WYVvOcmG8DOy3IQZd850xu4J1T2TO7rn4K3WOCUqiTcQHM9N/zAKanM/YV8GSN52ItiJUEW8qYFgTIhXxU0eQFUwoBV/d8l34GcJtQtrjkjv7+/k8mP3VuzMEKL+tYL4Tfn96LVG6qs9hTrIbKHwtxLSmzQWQqH3ZPXpUqENNv3+NBTijcdwG+4TC1He0njvB5/8TzuFzjxrBgtqayPphOX0JXrwZ1jcBIDyxVmnf0xJ2dqAJc6HyXP2nKeaOvPMhbqtjmibs/09x1im2VWdKxRG7cAQsme2YDmjNqX+up3AJitSVcLGQrKA0FWx/JvceV3wq2vc/19POc6+1X5XZb7C2ZjL2fPz1V8Y6JsQQq6OuiAWYGNCKXgjmOZy1PWbLWsuRGQq7S8MuFqub4/fMxAwD39Q/ltvcNuG+74u23Ui0nZj09OjE6EmAvKmDBxE59HzMm0Fpp0/4jIVZ4oHn5kXmd1qTKqhRNVtR/M5OQR5XceS6b29Yz1Pfewl/g7EhudizafimAmYmbLG4azjwAywC5xhMuJ7iI5IxCfONPzbz7q52KjwDspVj7XbUO9vd5J6b84uxFB2vcvWStFTWRAdoxKQfncs94T+FKWtZSgDOLL0wznu6sksfg6T6Au1M2DgCpDrSc6WWb/3qri379H7sft49Vyj66AAAAAElFTkSuQmCC">
          </li>
          <!-- <li  class="face-tab-item" v-for="(item, index) in bigEmojiList" :key="index" @click="selectFace(index+2)">
            <img :src="faceUrl + item.list[0] + '@2x.png'">
          </li> -->
        </ul>

      </main>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, watchEffect, watch, toRefs, computed, ref, onMounted } from 'vue';
import { emojiUrl, emojiMap, emojiName, faceUrl, bigEmojiList } from '../../utils/emojiMap';
import { onClickOutside } from '@vueuse/core';
import TUIAegis from '../../../../../utils/TUIAegis';
import { handleErrorPrompts } from '../../../utils';
import { getImageFileFromUrl } from '../../utils/utils';
import { userEmojiCreate, userEmojiList, userEmojiDel } from "@/request/api"

const Face = defineComponent({
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    isMute: {
      type: Boolean,
      default: () => false,
    },
    isH5: {
      type: Boolean,
      default: () => false,
    },
    parentID: {
      type: String,
      default: () => '',
    },
    showIndex: {
      type: Number,
      default: () => 0,
    },
    forbidClick: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props:any, ctx:any) {
    const data = reactive({
      componentName: 'Face',
      emojiUrl,
      emojiMap,
      emojiName,
      faceUrl,
      bigEmojiList,
      show: false,
      currentIndex: 0,
      isMute: false,
      transDom: false,
      visibleId: '',
      uplodImgAction: process.env.VUE_APP_UPLOAD_IMG_URL,
      autoEmojURL: process.env.VUE_APP_BASE_IMG_URL,
      myHeaders: {
          token: window.sessionStorage.getItem('HCZH-TOKEN')
      },
      uploadEmojiList: [],
      autoEmojiList: []
    });

    
    if (props.showIndex === 1) {
      data.currentIndex = 1
    }

    const dialog:any = ref();

    watchEffect(() => {
      data.show = props.show;
      data.isMute = props.isMute;
    });

    onMounted(() => {
      getAutoEmoj()
    })

    const toggleShow = () => {
      const display = dialog.value.style.display
      if (!data.isMute) {
        dialog.value.style.display = display === 'none' ? 'flex' : 'none';
      }
      if (display === 'none') {
        selectFace(0);
      }
      toggleH5Show();
    };

    const toggleH5Show = () => {
      const parent = document.getElementById(props.parentID);
      const main = document.getElementsByClassName('face-H5-main')[0];
      if (props.isH5) {
        parent?.appendChild(main);
      }
    };

    const getAutoEmoj = () => {
      userEmojiList({}).then( (res:any) => {
        if (res.code === 0) {
          data.autoEmojiList = res.data
        }
      })
    }

    const handleSuccess = (respose:any , file:any, fileList:any) =>{
      if (respose.code === 0) {
        const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo") || '{}');
        userEmojiCreate({
          imageUrl: respose.data,
          userId: userInfo.id
        }).then( (res:any) => {
          if (res.code === 0) {
            getAutoEmoj()
          }
        })
      }
    }

    const rightClick = (item:any, index:number, parentIndex:any) => {
      if (parentIndex === 1 && index !== 0) {
        data.visibleId = data.visibleId === item.id ? '' : item.id
      }
      
    }

    const delAutoEmoj = (item:any, index:number) => {
      userEmojiDel({
        "idList": [item.id]
      }).then( (res:any) => {
        if (res.code === 0) {
          getAutoEmoj()
        }
      })
    }

    onClickOutside(dialog, () => {
      if (props.forbidClick) return

      dialog.value.style.display  = 'none';
    });

    const select = async (item:any, index:number) => {
      data.visibleId = ''
      if (data.currentIndex === 1 && index === 0) return 
      
      const options:any = {
        name: item,
      };
      if (data.currentIndex === 0) {
        options.type = 'emo';
        options.url = emojiUrl + emojiMap[item];
        options.template = `<img src="${emojiUrl + emojiMap[item]}">`;
        if (!props.isH5) {
          toggleShow();
        }
        return ctx.emit('send', options);
      }

      try {
        if (data.currentIndex === 1 && index !== 0) {
          
          if (props.forbidClick) return
          
          getImageFileFromUrl(data.autoEmojURL + item.imageUrl,"fileName")
          .then( async (response)=> {
            const imageFile  = response
            await Face.TUIServer.sendImageMessage(imageFile);
            TUIAegis.getInstance().reportEvent({
              name: 'messageType',
              ext1: 'typeImage',
            });
          })
          .catch((e)=>{
            console.error(e)
          })
          
        } else {
          await Face.TUIServer.sendFaceMessage({
            // Change large expression display field
            index: data.bigEmojiList[data.currentIndex - 2].icon,
            data: data.bigEmojiList[data.currentIndex - 2].list[index],
          });
        }
        TUIAegis.getInstance().reportEvent({
          name: 'messageType',
          ext1: 'typeFace',
        });
      } catch (error) {
        handleErrorPrompts(error, props);
      }
      if (!props.isH5) {
        toggleShow();
      }
    };

    const list = computed(() => {
      const emjiList = [data.emojiName,['add']];
      for (let i = 0; i < data.autoEmojiList.length; i++) {
        emjiList[1].push(data.autoEmojiList[i]) 
      }
      
      // for (let i = 0; i < data.bigEmojiList.length; i++) {
      //   emjiList.push(data.bigEmojiList[i].list);
      // }
      return emjiList;
    });

    const selectFace = (index:number) => {
      data.currentIndex = index;
      data.visibleId = ''
    };

    return {
      ...toRefs(data),
      toggleShow,
      select,
      selectFace,
      rightClick,
      delAutoEmoj,
      handleSuccess,
      getAutoEmoj,
      list,
      dialog,
    };
  },
});
export default Face;
</script>

<style lang="scss" scoped src="./style/index.scss"></style>
